import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom typography utilities — must not conflict with Tailwind's text-color group
      'font-size': [
        'text-display-lg', 'text-display-sm',
        'text-headline-md', 'text-headline-sm',
        'text-title-md',
        'text-body-md', 'text-body-sm', 'text-body-md-sm',
        'text-label-lg', 'text-label-sm',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
